import React from 'react';
import { Link } from 'react-router-dom';

const Legal: React.FC = () => {
  return (
    <div className="container">
      <div className="header">
        <img className="wm-banner" src="/wm-banner.svg" alt="WM — In motion with me" />
        <h1>Legal Notice</h1>
        <p>Important information about safety, usage, and content responsibility.</p>
      </div>

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <p style={{ lineHeight: '1.8' }}>
          By using WM, you agree to follow all local laws and regulations while recording and
          sharing activities. Do not use the app in any way that may endanger yourself or others.
          You are responsible for the content you share and the privacy of any participants.
        </p>
        <p style={{ lineHeight: '1.8', marginTop: '1rem' }}>
          WM is provided “as is” without warranties of any kind. Availability and features may
          change over time. For questions or concerns, contact support through the Help page.
        </p>
      </div>

      <div className="card" style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '1rem' }}>Start a new event</h2>
        <Link to="/create">
          <button className="button button-primary">Create New Event</button>
        </Link>
      </div>
    </div>
  );
};

export default Legal;
